import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'nk-report-container',
  templateUrl: './report-container.component.html',
  styleUrls: ['./report-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReportContainerComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
